// Integración del formulario de facturación (carrito) con el checkout de Shopify.
// Guarda los datos capturados como cart attributes (note_attributes del pedido) y,
// además, pre-llena email/ciudad/departamento en el checkout vía Storefront API
// (cartBuyerIdentityUpdate) operando sobre el MISMO carrito frontend — no crea uno nuevo.

// ─── Utilidades ───────────────────────────────────────────────────────────────

function urlFormatter(url, parameters) {
  var parts = url.split('?');
  var base = parts[0];
  var map = {};

  if (parts[1]) {
    parts[1].split('&').forEach(function (kv) {
      var idx = kv.indexOf('=');
      if (idx > 0) map[kv.substring(0, idx)] = decodeURIComponent(kv.substring(idx + 1));
    });
  }

  parameters.forEach(function (p) {
    map[p.name] = p.value;
  });

  var qs = Object.keys(map).map(function (k) {
    return k + '=' + encodeURIComponent(map[k]);
  }).join('&');

  return qs ? base + '?' + qs : base;
}

// ─── Storefront API — actualizar buyer identity del carrito existente ─────────
//
// cartBuyerIdentityUpdate opera sobre el carrito frontend EXISTENTE (no crea uno nuevo).
// El token del carrito frontend (/cart.js → .token) es el mismo GID del Cart API.

function updateCartBuyerIdentity(cartToken, email, deliveryAddress) {
  var config = window.moxBillingConfig || {};
  var token = config.storefrontToken;
  var domain = config.shopDomain;

  if (!token || !domain) {
    return Promise.reject(new Error('moxBillingConfig no disponible'));
  }

  var mutation =
    'mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {' +
    '  cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {' +
    '    cart { id checkoutUrl }' +
    '    userErrors { field message }' +
    '  }' +
    '}';

  return fetch('https://' + domain + '/api/2024-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token
    },
    body: JSON.stringify({
      query: mutation,
      variables: {
        cartId: 'gid://shopify/Cart/' + cartToken,
        buyerIdentity: {
          email: email,
          deliveryAddressPreferences: [
            { deliveryAddress: deliveryAddress }
          ]
        }
      }
    })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var result = data.data && data.data.cartBuyerIdentityUpdate;
      if (result && result.cart && result.cart.checkoutUrl) {
        return result.cart.checkoutUrl;
      }
      throw new Error('cartBuyerIdentityUpdate no devolvió checkoutUrl');
    });
}

// ─── Validación del formulario de facturación ─────────────────────────────────
//
// billingComputeValidity() es la única fuente de verdad de las reglas por campo.
// billingValidateForm() la usa para marcar TODOS los campos al intentar pagar;
// billingValidateField() la usa para marcar UN campo al perder el foco (blur),
// así el warning debajo de cada campo aparece apenas el usuario lo completa mal.

var billingDocNumberRules = {
  'Cédula de Ciudadanía': { min: 6, max: 10 },
  'Tarjeta de Identidad': { min: 8, max: 11 },
  'Cédula de Extranjería': { min: 6, max: 9 },
  'NIT': { min: 9, max: 10 },
  'Pasaporte': { min: 6, max: 12 }
};

function billingEl(id) { return document.getElementById(id); }
function billingVal(id) {
  var e = billingEl(id);
  if (!e) return '';
  return e.value ? e.value.trim() : '';
}
function billingMarkRow(rowId, isError) {
  var wrap = billingEl(rowId);
  if (!wrap) return;
  if (isError) {
    wrap.setAttribute('data-invalid', 'true');
    wrap.removeAttribute('data-valid');
  } else {
    wrap.removeAttribute('data-invalid');
  }
}
function billingIsEmailValid(email) {
  return !!email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
function billingIsDocNumberValid(tipoDoc, numDoc) {
  if (!numDoc) return false;
  var rule = billingDocNumberRules[tipoDoc];
  if (!rule) return true;
  var digitsOnly = tipoDoc !== 'Pasaporte';
  if (digitsOnly && !/^\d+$/.test(numDoc)) return false;
  return numDoc.length >= rule.min && numDoc.length <= rule.max;
}

function billingComputeValidity() {
  var tipoDoc = billingVal('mox-cf-doc-type');
  var termsEl = billingEl('mox-cf-terms');

  return {
    'mox-cf-row-department': !!billingVal('mox-cf-department'),
    'mox-cf-row-city': !!billingVal('mox-cf-city'),
    'mox-cf-row-doctype': !!tipoDoc,
    'mox-cf-row-docnumber': billingIsDocNumberValid(tipoDoc, billingVal('mox-cf-doc-number')),
    'mox-cf-row-email': billingIsEmailValid(billingVal('mox-cf-email')),
    'mox-cf-row-terms': !termsEl || termsEl.checked
  };
}

// Valida y marca UN solo campo (usado en el evento 'blur' de cada input/select).
function billingValidateField(rowId) {
  var validity = billingComputeValidity();
  billingMarkRow(rowId, !validity[rowId]);
  return validity[rowId];
}

// Valida y marca TODOS los campos (usado al hacer click en "Finalizar compra").
function billingValidateForm() {
  var validity = billingComputeValidity();
  Object.keys(validity).forEach(function (rowId) {
    billingMarkRow(rowId, !validity[rowId]);
  });

  if (!validity['mox-cf-row-department']) return { valid: false, message: 'Seleccione un departamento.' };
  if (!validity['mox-cf-row-city']) return { valid: false, message: 'Seleccione una ciudad.' };
  if (!validity['mox-cf-row-doctype']) return { valid: false, message: 'Seleccione un tipo de documento.' };
  if (!validity['mox-cf-row-docnumber']) return { valid: false, message: 'Ingrese un número de documento válido para el tipo seleccionado.' };
  if (!validity['mox-cf-row-email']) return { valid: false, message: 'Ingrese un correo electrónico válido.' };
  if (!validity['mox-cf-row-terms']) return { valid: false, message: 'Debes aceptar los términos y condiciones.' };

  return { valid: true };
}

// ─── Transferencia al checkout ────────────────────────────────────────────────

function transferBillingDataToCheckout() {
  function getVal(id) {
    var e = document.getElementById(id);
    return e ? (e.value || '') : '';
  }

  var departamento = getVal('mox-cf-department');
  var ciudad = getVal('mox-cf-city');
  var tipoDoc = getVal('mox-cf-doc-type');
  var numDoc = getVal('mox-cf-doc-number');
  var email = getVal('mox-cf-email');

  // cart.attributes → note_attributes del pedido ("Información adicional" en el Admin).
  // Se guardan TODOS los datos capturados, incluso los que no son campos nativos
  // de dirección de Shopify (tipo/número de documento).
  var attributes = {
    Departamento: departamento,
    Ciudad: ciudad,
    Tipo_Documento: tipoDoc,
    Numero_Documento: numDoc,
    Correo_Electronico: email
  };

  // Dirección para pre-llenar el checkout via buyer identity (solo campos capturados).
  // El checkout de esta tienda reutiliza el campo nativo "company" (name="company")
  // para mostrar la Cédula/NIT, por eso el número de documento va ahí.
  var deliveryAddress = {
    company: numDoc,
    city: ciudad,
    province: departamento,
    country: 'CO'
  };

  // Fallback: URL params si la Storefront API falla (token inválido, red, etc.)
  var parameters = [{ name: 'checkout[shipping_address][country]', value: 'CO' }];
  if (numDoc) parameters.push({ name: 'checkout[shipping_address][company]', value: numDoc });
  if (ciudad) parameters.push({ name: 'checkout[shipping_address][city]', value: ciudad });
  if (departamento) parameters.push({ name: 'checkout[shipping_address][province]', value: departamento });
  if (email) parameters.push({ name: 'checkout[email]', value: email });

  var urlParamsFallback = urlFormatter('/checkout', parameters);

  // PASO 1: guardar atributos en el carrito → note_attributes del pedido
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributes })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      // PASO 2: actualizar buyer identity en el carrito existente (mismo token/GID)
      return updateCartBuyerIdentity(cart.token, email, deliveryAddress);
    })
    .then(function (checkoutUrl) {
      window.location.href = checkoutUrl;
    })
    .catch(function () {
      // Si la API falla, redirigir con URL params (funciona incluso sin token configurado)
      window.location.href = urlParamsFallback;
    });
}

// ─── Interceptación de botones/links de checkout del tema ─────────────────────

function setupCheckoutIntegration() {
  var checkoutButtons = document.querySelectorAll(
    'button[name="checkout"], .btn-checkout, .btn-cart-checkout, [href*="/checkout"], ' +
    '.cart__checkout, .cart__submit'
  );

  checkoutButtons.forEach(function (button) {
    if (button.dataset.moxCheckoutBound === '1') return;
    button.dataset.moxCheckoutBound = '1';

    button.addEventListener('click', function (e) {
      if (!document.getElementById('mox-cf-department')) return; // no hay form de facturación en esta página

      var validation = billingValidateForm();
      if (!validation.valid) {
        e.preventDefault();
        e.stopPropagation();
        var billingForm = document.getElementById('mox-checkout-form');
        if (billingForm) billingForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return false;
      }

      e.preventDefault();
      e.stopPropagation();
      transferBillingDataToCheckout();
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setupCheckoutIntegration();
});

window.addEventListener('load', setupCheckoutIntegration);
